"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.pushProductToDataLayer = exports.pushToDataLayerNavigation = exports.pushToDataLayer = void 0;
const translation_1 = require("../../common/js/helper/translation");
const DataLayerEvents_1 = __importDefault(require("../enums/DataLayerEvents"));
const DataLayerLabels_1 = __importDefault(require("../enums/DataLayerLabels"));
const product_1 = require("./product");
const pushToDataLayer = (eventData) => {
    const dataLayerPush = window.dataLayer || [];
    dataLayerPush.push(eventData);
};
exports.pushToDataLayer = pushToDataLayer;
const pushToDataLayerNavigation = (eventData) => {
    const { isProduct, ...eventInfo } = eventData;
    let event = DataLayerEvents_1.default.dlvMainNavigation;
    if (isProduct) {
        event = DataLayerEvents_1.default.dlvProduct;
    }
    const dataLayerPush = window.dataLayer || [];
    dataLayerPush.push({
        ...{
            [DataLayerLabels_1.default.dlvNavigationLevelOne]: eventInfo[DataLayerLabels_1.default.dlvNavigationLevelOne],
            [DataLayerLabels_1.default.dlvNavigationLevelTwo]: eventInfo[DataLayerLabels_1.default.dlvNavigationLevelTwo],
            [DataLayerLabels_1.default.dlvNavigationLevelThree]: eventInfo[DataLayerLabels_1.default.dlvNavigationLevelThree],
            [DataLayerLabels_1.default.dlvProductTitle]: eventInfo[DataLayerLabels_1.default.dlvProductTitle],
        },
        event,
    });
};
exports.pushToDataLayerNavigation = pushToDataLayerNavigation;
const pushProductToDataLayer = (product) => {
    if (!product) {
        return;
    }
    (0, exports.pushToDataLayerNavigation)({
        [DataLayerLabels_1.default.dlvNavigationLevelOne]: (0, translation_1.t)('navigation.shop.title'),
        [DataLayerLabels_1.default.dlvNavigationLevelTwo]: (0, product_1.getCategoryNameOfProduct)(product),
        [DataLayerLabels_1.default.dlvProductTitle]: product.translated?.name,
        isProduct: true,
    });
};
exports.pushProductToDataLayer = pushProductToDataLayer;
